import fetchWithTimeout from "../../utils/fetchWithTimeout";

export default async function addToFavorites(formData) {
  return await fetchWithTimeout(
    favoritesVars.ajaxUrl,
    {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        action: "add_to_favorites",
        product_id: formData.get("product_id"),
        nonce: favoritesVars.nonce,
      }).toString(),
    },
    5000,
    "addToFavorites"
  );
}
